import { render, staticRenderFns } from "./XlsUpload.vue?vue&type=template&id=dd9716de&scoped=true"
import script from "./XlsUpload.vue?vue&type=script&lang=js"
export * from "./XlsUpload.vue?vue&type=script&lang=js"
import style0 from "./XlsUpload.vue?vue&type=style&index=0&id=dd9716de&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd9716de",
  null
  
)

export default component.exports